import * as React from 'react'
import styled from 'styled-components'

import AspectRatio from 'components/utils/AspectRatio'

export const IPHONE_14_CROPPED_FRAME_SYMBOL_ID = 'iphone-14-cropped-frame'

// for some unknown sinister reason <symbol> is getting rendered as a transparent box taking some space!
export const HiddenSvg = styled.svg`
  display: none;
`

const IPhoneFrame = styled(AspectRatio)`
  position: relative;
`

const DisplayViewport = styled.div`
  width: 100%;
  height: 100%;
  /* What are these weird values? They're supposed to offset the content within the iPhone frame. */
  padding: 17.8% 4.2% 0;
  display: flex;
  flex-direction: column;
`

const IPhoneFrameOverlay = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`

interface Props {
  children?: React.ReactNode
  className?: string
}

export default function IPhone14CroppedFrame(props: Props) {
  const { children, className } = props
  return (
    <IPhoneFrame ratio="205:299" className={className}>
      <DisplayViewport>{children}</DisplayViewport>
      <IPhoneFrameOverlay role="presentation">
        <use xlinkHref={`#${IPHONE_14_CROPPED_FRAME_SYMBOL_ID}`} />
      </IPhoneFrameOverlay>
    </IPhoneFrame>
  )
}
